import cleanUpResponse from '@/util/cleanUpResponse';

export default async function GetOFMFDMaintenanceByOrderId(orderId) {
  const response = await $.soap({
    body: {
      GetOFMFDMaintenanceByOrderId: {
        $xmlns: 'http://dla.mil/ems/bpm/order/order_form',
        OrderId: orderId
      }
    },
    blueprint: {
      order: {
        orderId: '$..OrderID',
        isCACCardPIVReader: '$..IsCACCardPIVReader',
        specialBaseBuildingAccessReq: '$..SpecialBaseBuildingAccessReq',
        specialBaseBuildingAccessNotes: '$..SpecialBaseBuildingAccessNotes',
        maintenanceStartDate: '$..MaintenanceStartDate',
        durationMonths: '$..DurationMonths',
        numDevicesForMaintenance: '$..NumDevicesForMaintenance',
        numOnsiteTechnicians: '$..NumOnsiteTechnicians',
        numFirmwareSoftwareUpdates: '$..NumFirmwareSoftwareUpdates',
        itPOCID: '$..ITPOCID',
        customerSignature: '$..CustomerSignature',
        crsSignature: '$..CRSSignature',
        ecpSignature: '$..EPCSignature',
        totalOrderQuantity: '$..TotalOrderQuantity',
        createdOn: '$..CreatedOn',
        createdBy: '$..CreatedBy',
        updatedOn: '$..UpdatedOn',
        updatedBy: '$..UpdatedBy',
        dateEquipmentReq: '$..DateEquipmentReq',
        firstName: '$..POCFirstName',
        lastName: '$..POCLastName',
        email: '$..POCEmail',
        telephone: '$..POCTelephone'
      }
    }
  });

  cleanUpResponse(response);
  return response.order;
}
